module.exports = __webpack_public_path__ + "static/media/crystal-pendent_720x480.a89f265c.jpg";